import PropTypes from "prop-types";
import React, { Component } from "react";
import { Link } from "react-router-dom";
import styles from "../styles/home.css";
import {
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility
} from "semantic-ui-react";

//backgroundImage: `url(../images/NiceHome.jpg)`
// Heads up!
// We using React Static to prerender our docs with server side rendering, this is a quite simple solution.
// For more advanced usage please check Responsive docs under the "Usage" section.
const getWidth = () => {
  const isSSR = typeof window === "undefined";

  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth;
};

/* eslint-disable react/no-multi-comp */
/* Heads up! HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled components for
 * such things.
 */
const HomepageHeading = ({ mobile }) => (
  <Container text>
    <Header
      as="h1"
      content="Bangladesh Development Project"
      inverted
      style={{
        fontSize: mobile ? "2em" : "4em",
        fontWeight: "normal",
        marginBottom: 0,
        marginTop: mobile ? "1.5em" : "3em"
      }}
    />
    <Header
      as="h2"
      content="Help save your people."
      inverted
      style={{
        fontSize: mobile ? "1.5em" : "1.7em",
        fontWeight: "normal",
        marginTop: mobile ? "0.5em" : "1.5em"
      }}
    />
    <Link to="/donate">
      <Button primary size="huge" style={{ background: "rgb(47, 137, 60)" }}>
        Donate
        <Icon name="right arrow" />
      </Button>
    </Link>
  </Container>
);

HomepageHeading.propTypes = {
  mobile: PropTypes.bool
};

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {};

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  render() {
    const { children } = this.props;
    const { fixed } = this.state;

    return (
      <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >
          <Segment
            inverted
            textAlign="center"
            style={{
              minHeight: 700,
              padding: "1em 0em",
              color: "transparent"
            }}
            vertical
          >
            <HomepageHeading />
          </Segment>
        </Visibility>
        {children}
      </Responsive>
    );
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node
};

class MobileContainer extends Component {
  state = {};

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });

  render() {
    const { children } = this.props;
    const { sidebarOpened } = this.state;

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation="push"
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          <Menu.Item as={Link} to="/">
            Home
          </Menu.Item>
          <Menu.Item as={Link} to="/issues">
            Issues
          </Menu.Item>
          <Menu.Item as={Link} to="/projects">
            Projects
          </Menu.Item>
          <Menu.Item as={Link} to="/donate">
            Donate
          </Menu.Item>
          <Menu.Item as={Link} to="/team">
            Team
          </Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign="center"
            style={{
              minHeight: 350,
              padding: "1em 0em"
            }}
            vertical
          >
            <Container>
              <Menu
                inverted
                pointing
                secondary
                size="large"
                style={{ background: "rgb(165, 18, 18)" }}
              >
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name="sidebar" />
                </Menu.Item>
                <Menu.Item position="right">
                  <Button inverted size="large" as={Link} to="/donate">
                    Donate
                  </Button>
                </Menu.Item>
              </Menu>
            </Container>
            <HomepageHeading mobile />
          </Segment>

          {children}
        </Sidebar.Pusher>
      </Responsive>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node
};

const ResponsiveContainer = ({ children }) => (
  <div>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </div>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node
};

const HomepageLayout = () => (
  <ResponsiveContainer>
    <Segment style={{ padding: "8em 0em" }} vertical>
      <Grid container stackable verticalAlign="middle">
        <Grid.Row>
          <Grid.Column floated="left" width={6}>
            <Image
              bordered
              rounded
              size="large"
              src={require("../images/Education_Flyer.jpg")}
            />
          </Grid.Column>
          <Grid.Column width={8}>
            <Header
              as="h3"
              style={{ fontSize: "3em", color: "rgb(165, 18, 18)" }}
            >
              The Latest
            </Header>

            <p style={{ fontSize: "2em" }}>
              Education is the world's greatest equalizer. Unfortunately, many
              of the youth cannot afford to pay for their tuition fees. With
              only $12, you can sponsor an entire month of education for a child
              in need.
            </p>
            <Link to="/donate">
              <Button
                size="huge"
                style={{
                  background: "rgb(47, 137, 60)",
                  color: "white",
                  marginRight: "15px"
                }}
              >
                I want to help
              </Button>
            </Link>
            <Link to="/projects/education2019">
              <Button
                size="huge"
                style={{ background: "rgb(47, 137, 60)", color: "white" }}
              >
                Read More
              </Button>
            </Link>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>

    <Segment style={{ padding: "8em 0em" }} vertical>
      <Grid container stackable verticalAlign="middle">
        <Grid.Row>
          <Grid.Column width={8}>
            <Header
              as="h3"
              style={{ fontSize: "3em", color: "rgb(165, 18, 18)" }}
            >
              Our Mission
            </Header>
            <p style={{ fontSize: "2em" }}>
              As young Bangladeshis in the United States, we believe that it is
              imperative to shed light on the injustices imposed on
              underprivileged children in Bangladesh. Unjust labor laws, unequal
              educational opportunities, and healthcare inequities are everyday
              realities that we cannot escape. Let us unite and work diligently
              to ensure that no Bangladeshis are left behind.
            </p>
          </Grid.Column>
          <Grid.Column floated="right" width={6}>
            <Image
              bordered
              rounded
              size="large"
              src={require("../images/oldteam.jpg")}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <Link to="/team">
              <Button
                size="huge"
                style={{ background: "rgb(47, 137, 60)", color: "white" }}
              >
                Check Out Our Team
              </Button>
            </Link>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
    <Segment style={{ padding: "0em" }} vertical>
      <Grid celled="internally" columns="equal" stackable>
        <Grid.Row textAlign="center">
          <Grid.Column style={{ paddingBottom: "5em", paddingTop: "5em" }}>
            <Header
              as="h3"
              style={{ fontSize: "2em", color: "rgb(165, 18, 18)" }}
            >
              We Help Our Blood.
            </Header>
            <p style={{ fontSize: "1.33em" }}>
              We help raise awareness of the issues in Bangladesh that are
              hidden and we help solve them. With Your help, we can save the
              world, one person at a time.
            </p>
          </Grid.Column>
          <Grid.Column style={{ paddingBottom: "5em", paddingTop: "5em" }}>
            <Header
              as="h3"
              style={{ fontSize: "2em", color: "rgb(165, 18, 18)" }}
            >
              We Connect People
            </Header>
            <p style={{ fontSize: "1.33em" }}>
              We help reignite the connections between Bengali Americans with
              their people back home. Break the barriers of distance today!
            </p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Segment>
    <Segment style={{ padding: "8em 0em" }} vertical>
      <Container text>
        <Header as="h3" style={{ fontSize: "2em", color: "rgb(165, 18, 18)" }}>
          Did you know that prostitution is still legalized in Bangladesh?
        </Header>
        <p style={{ fontSize: "1.33em" }}>
          Bangladesh is one of the fastest growing third world countries in the
          world, yet it is still riddled with issues that are difficult to
          solve. These issues include prostitution, healthcare, early marriage,
          child labor, and education.
        </p>
        <Link to="/issues">
          <Button
            as="a"
            size="large"
            style={{ background: "rgb(47, 137, 60)", color: "white" }}
          >
            Read More
          </Button>
        </Link>

        <Divider
          as="h4"
          className="header"
          horizontal
          style={{ margin: "3em 0em", textTransform: "uppercase" }}
        >
          <a href="#" style={{ color: "rgb(18, 80, 28)" }}>
            News
          </a>
        </Divider>
        <Header as="h3" style={{ fontSize: "2em", color: "rgb(165, 18, 18)" }}>
          2019 Ramadan Project
        </Header>
        <p style={{ fontSize: "1.33em" }}>
          This Ramadan, BDP was incredibly successful in its largest project
          yet. Within just a few days we were able to raise enough money to feed
          over a thousand starving people.
        </p>
        <Link to="/projects">
          <Button
            as="a"
            size="large"
            style={{ background: "rgb(47, 137, 60)", color: "white" }}
          >
            Read more about our projects
          </Button>
        </Link>
      </Container>
    </Segment>
  </ResponsiveContainer>
);
export default HomepageLayout;
